const ROOM_SIZE = 4;
const DEFAULT_MAX_TRAVELERS = 8;
const DEFAULT_MAX_ROOMS = 4;
const HOTEL_CHILD_DISCLAIMER = "Add your child's age at check-in for the best deals and assistance. Each hotel has unique policies.";
const PET_FRIENDLY_LABEL = 'Pet friendly';
const CHILDREN_AGE_ERROR_MESSAGE = "Please enter children's ages to get the best price for your group";
const INTERNATIONAL_LAP_INFANT_ERROR_MESSAGE = 'Sorry, Priceline does not offer lap infant seating on international flights';
const WHITE_LABEL_INTERNATIONAL_LAP_INFANT_ERROR_MESSAGE = 'Sorry, we do not offer lap infant seating on international flights';
export { CHILDREN_AGE_ERROR_MESSAGE, DEFAULT_MAX_ROOMS, DEFAULT_MAX_TRAVELERS, HOTEL_CHILD_DISCLAIMER, INTERNATIONAL_LAP_INFANT_ERROR_MESSAGE, PET_FRIENDLY_LABEL, ROOM_SIZE, WHITE_LABEL_INTERNATIONAL_LAP_INFANT_ERROR_MESSAGE };
